const PropertyCardPrimaryStatContainer = ({ primary }) => (
  <div className="property-card-primary-stat-container">
    <div className="property-card-primary-stat-container__stat-box">
      {primary}
    </div>
  </div>
);

export default PropertyCardPrimaryStatContainer;
